var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M20.328 9.957c0-.787-.07-1.361-.22-1.957h-9.78v3.553h5.74c-.115.883-.74 2.213-2.129 3.106l-.02.12 3.093 2.201.214.02c1.968-1.67 3.102-4.128 3.102-7.043"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M10.517 20c2.777 0 5.108-.887 6.811-2.416l-3.246-2.437c-.868.587-2.034.997-3.565.997-2.72 0-5.029-1.74-5.852-4.144l-.12.01-3.175 2.382-.042.112C3.02 17.762 6.494 20 10.517 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M4.328 11.496a6.6 6.6 0 0 1-.31-1.972c0-.687.114-1.351.3-1.972l-.005-.132L1.413 5l-.095.048a10.6 10.6 0 0 0-.99 4.476c0 1.607.361 3.124.99 4.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M10.478 3.856c1.923 0 3.22.809 3.96 1.485l2.89-2.748C15.553.986 13.243 0 10.478 0c-4.006 0-7.466 2.238-9.15 5.496L4.64 8a6.18 6.18 0 0 1 5.837-4.144"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.328 0h20v20h-20z"
  })))));
};
export default SvgGoogle;